export class ArchivePlateListRequestDTO {
    archiveBatchSourceIds: string[];
    mapOfSourceBatchStorage: any;
    mapOfSourceBatchAndSampleCount: any;
}